export default __webpack_public_path__ + "static/media/hand-holding-medical-solid.3ed05ebd.svg";